import { render } from "./employee-christian.vue?vue&type=template&id=f2277028"
import script from "./employee-christian.vue?vue&type=script&lang=js"
export * from "./employee-christian.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__